import React from 'react';
import { motion } from 'framer-motion';

const Community = () => {
  return (
    <div className="min-h-screen mystical-bg py-32">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <motion.div
          initial={{ opacity: 0, y: 20 }}
          animate={{ opacity: 1, y: 0 }}
          transition={{ duration: 0.8 }}
          className="text-center"
        >
          <h1 className="text-5xl sm:text-6xl lg:text-7xl font-heading font-bold golden-text text-glow uppercase tracking-widest mb-8">
            COMMUNITY
          </h1>
          <p className="text-xl text-primary/80 max-w-3xl mx-auto leading-relaxed">
            Join fellow seekers on the path. The community space is under construction.
          </p>
        </motion.div>
      </div>
    </div>
  );
};

export default Community;